<span
  class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap"
  [ngClass]="presentation().classes"
  [attr.data-variant]="variant"
>
  @if (showSpinner()) {
    <span
      class="inline-block h-2 w-2 rounded-full bg-blue-500 animate-pulse"
      aria-hidden="true"
    ></span>
  }
  {{ presentation().label }}
</span>
